<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商编码">
              <global-select
                :value.sync="queryParams.supplierCode"
                selectType="selectSearch"
                requestApi="/mdm/mdmOrgSupplier/supplierCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="supplierCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商名称">
              <global-select
                :value.sync="queryParams.supplierName"
                selectType="selectSearch"
                requestApi="/mdm/mdmOrgSupplier/supplierNameList"
                :selectItem="{ value: 'realValue', label: 'realValue' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商类别">
              <global-select
                :value.sync="queryParams.supplierClass"
                selectType="selectSearch"
                requestApi="/mdm/mdmOrgSupplier/supplierClassList"
                :selectItem="{ value: 'label', label: 'realValue' }"
                searchParam="supplierClass"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="供应商简称">
                <global-select
                  :value.sync="queryParams.supplierAbbreviation"
                  selectType="selectSearch"
                  requestApi="/mdm/mdmOrgSupplier/supplierAbbreviationList"
                  :selectItem="{ value: 'label', label: 'label' }"
                  searchParam="supplierAbbreviation"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="供应商简码">
                <global-select
                  :value.sync="queryParams.supplierBrevityCode"
                  selectType="selectSearch"
                  requestApi="/mdm/mdmOrgSupplier/supplierBrevityCodeList"
                  :selectItem="{ value: 'label', label: 'label' }"
                  searchParam="supplierBrevityCode"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomConversions:export']">导出</a-button>
    </div> -->
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <template slot="warehouseCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.warehouseCode }}</span>
            <!-- <a-input-number step="1" v-if="isEdit && currentId === record.id" v-model="record.warehouseCode" :min="0" />  realValue-->
            <a-select size="small" v-if="isEdit && currentId === record.id" v-model="record.warehouseCode" >
              <a-select-option v-for="(item) in warehouseOptions" :key="item.label">{{ item.label }}</a-select-option>
            </a-select>

          </template>
          <template slot="destLatitude" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.destLatitude }}</span>
            <a-input-number size="small" step="0.1" v-if="isEdit && currentId === record.id" v-model="record.destLatitude" :min="0" />
          </template>
          <template slot="destLongitude" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.destLongitude }}</span>
            <a-input-number size="small" step="0.1" v-if="isEdit && currentId === record.id" v-model="record.destLongitude" :min="0" />
          </template>
          <template slot="deliveryLeadtime" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.deliveryLeadtime }}</span>
            <a-input-number step="1" v-if="isEdit && currentId === record.id" v-model="record.deliveryLeadtime" :min="0" />
          </template>
          <template slot="serialNum" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.serialNum }}</span>
            <a-input-number size="small"  step="1" v-if="isEdit && currentId === record.id" v-model="record.serialNum" :min="1" />
          </template>
          <template slot="time" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmOrgSupplier:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiMdmOrgSupplierList, apiMdmOrgSupplier, apiMdmSelectSupplierWarehouse } from '@/api/mdm/supplier/supplier'

import { generateLsTableResData } from '@/utils/util.js';
export default {
  name: 'Supplier',
  components: {
  },
  data () {
    return {
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMdmOrgSupplierList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierCode: undefined,
        supplierName: undefined,
        supplierClass: undefined,
        supplierAbbreviation: undefined,
        supplierBrevityCode: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          fixed: 'left',
          align: 'center',
          ellipsis: true,
          width: 140
        },
        {
          title: '供应商名称',
          width: 220,
          dataIndex: 'supplierName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商类型',
          dataIndex: 'supplierType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商类型',
          dataIndex: 'supplierTypeName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '供应商简称',
          dataIndex: 'supplierAbbreviation',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '供应商简码',
          dataIndex: 'supplierBrevityCode',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '供应商类别',
          dataIndex: 'supplierClassDesc',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '加工厂分组编码',
          dataIndex: 'pdGroup',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '加工厂分组',
          dataIndex: 'supplierPdGroupName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '材料商分组',
          dataIndex: 'supplierMdGroup',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '材料商分组名称',
          dataIndex: 'supplierMdGroupName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '采购组织编码',
          dataIndex: 'purchaseOrgCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '采购组织名称',
          dataIndex: 'purchaseOrgName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '加工厂合作状态',
          dataIndex: 'pdStatus',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '加工厂合作状态',
          dataIndex: 'pdStrStatus',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '材料商合作状态',
          dataIndex: 'mdStatus',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '材料商合作状态',
          dataIndex: 'mdStrStatus',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '地址',
          dataIndex: 'supplierAddress',
          width: 220,
          ellipsis: true,
          align: 'left'
        },
        {
          title: '省级编码',
          dataIndex: 'provinceCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'province',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '城市编码',
          dataIndex: 'cityCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '城市',
          dataIndex: 'city',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '税率',
          dataIndex: 'taxRate',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '地址纬度',
          dataIndex: 'destLatitude',
          scopedSlots: { customRender: 'destLatitude' },
          width: 160,
          align: 'center'
        },
        {
          title: '地址经度',
          dataIndex: 'destLongitude',
          scopedSlots: { customRender: 'destLongitude' },
          width: 160,
          align: 'center'
        },
        {
          title: '仓库编码',
          dataIndex: 'warehouseCode',
          fixed: 'right',
          scopedSlots: { customRender: 'warehouseCode' },
          width: 160,
          align: 'center'
        },
        {
          title: '要货提前期（天）',
          dataIndex: 'deliveryLeadtime',
          fixed: 'right',
          scopedSlots: { customRender: 'deliveryLeadtime' },
          width: 150,
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'serialNum',
          fixed: 'right',
          scopedSlots: { customRender: 'serialNum' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
    apiMdmSelectSupplierWarehouse().then().then(response => {
      this.warehouseOptions = response
    })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/mdmUomConversions/export', {
        ...this.queryParams
      }, `标准单位转换_${new Date().getTime()}.xlsx`)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.deliveryLeadtime || Number(record.deliveryLeadtime) <= 0) {
        this.$message.warning('要货提前期不能小于等于0！')
        return
      }
      if (!record.serialNum || Number(record.serialNum) < 1) {
        this.$message.warning('排序不能小于1！')
        return
      }
      apiMdmOrgSupplier(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-select{
  width: 100%;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
